


















import {Vue, Component, Prop} from "vue-property-decorator";
import FormGroup from "@/components/ui/forms/FormGroup.vue";
import {HashMap} from "./../services/base.service";
import ServiceService, {IService} from "./../services/service.service";

@Component
export default class ServiceList extends Vue {

    private list: IService[] = [];
    private service!: ServiceService;

    private async getList() {
        const res = await this.service.get();
        if (res.success) {
            this.list = res.result;
        }
    }

    private created() {
        this.service = new ServiceService();
        this.getList();
    }
}

